import React from 'react';
import { createRoot } from 'react-dom/client';
import RouterPublic from './RouterPublic';
import QueryClientProvider from './comp/HOC/QueryClientProvider';

const container = document.getElementById('main');
const root = createRoot(container);

root.render(
  <QueryClientProvider>
    <RouterPublic />
  </QueryClientProvider>
);
